import httpClient from '/src/utils/httpClient';

export function getEmailApiCall(id) {
  const profileId = localStorage.getItem('unilinkProfileId');
  return httpClient.get(`api/profiles/${profileId}/email-marketing/emails/${id}`);
}
